import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalService, ModalConfig } from './modal.service';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {
  heading: string = '';
  description: string = '';
  primaryButtonText: string = '';
  secondaryButtonText: string = '';
  isVisible: boolean = false;
  modalId: string = '';

  private readonly subscriptions: Subscription = new Subscription();

  constructor(private readonly modalService: ModalService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.modalService.modalConfig$.subscribe((config: ModalConfig | null) => {
        if (config) {
          this.heading = config.heading;
          this.description = config.description;
          this.primaryButtonText = config.primaryButtonText || '';
          this.secondaryButtonText = config.secondaryButtonText || '';
          this.modalId = config.modalId;
        }
      })
    );

    this.subscriptions.add(
      this.modalService.isVisible$.subscribe((isVisible: boolean) => {
        this.isVisible = isVisible;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onPrimaryClick(): void {
    this.modalService.emitPrimaryClick(this.modalId);
  }

  onSecondaryClick(): void {
    this.modalService.emitSecondaryClick(this.modalId);
  }

  onClose(): void {
    this.modalService.hide();
  }
}